import React, {useState} from "react";
import {
    Datagrid,
    DateField,
    Filter,
    List,
    SelectInput,
    SimpleShowLayout,
    TextField,
    TextInput,
    required,
    BooleanField,
    BooleanInput,
    ReferenceField, ReferenceInput
} from "react-admin";
import CreateView from "../../components/CreateView";
import EditView from "../../components/EditView";
import ShowView from "../../components/ShowView";
import { PersianDateExpirationDatePicker } from "../../components/PersianDatePickers";

const SubscriptionFilter = (props) => (
  <Filter {...props}>
      <TextInput
          label="شناسه کاربر"
          source={"userId"}
      />
  </Filter>
);

export const SubscriptionList = (props) => (
  <List {...props} filters={<SubscriptionFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
        <ReferenceField link="show"  label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
    </Datagrid>
  </List>
);

export const SubscriptionCreate = (props) => {
    const [expirationDate, setExpirationDate] = useState(new Date().setHours(0,0));
    function expirationDateChange(e){
        setExpirationDate(e._d.setHours(0,0))
    }
    return (
        <CreateView {...props} perPage={10}>
            <ReferenceInput label="نوع پلن" validate={required()} source="planTypeId" reference="planType">
                <SelectInput optionText="title" alwaysOn/>
            </ReferenceInput>
            <TextInput  source="userId" validate={required()}/>
            <BooleanInput source="isDeleted" defaultValue={false}/>

            <PersianDateExpirationDatePicker
                name="expirationDate"
                value={expirationDate}
                onChange={expirationDateChange}
                label={"تاریخ انقضا"}
            />
        </CreateView>
    );
}


export const SubscriptionEdit = (props) => {
    return (
        <EditView {...props}>
            <BooleanInput source="isDeleted" defaultValue={false}/>
            <PersianDateExpirationDatePicker
                source="expirationDate"
                label={"تاریخ انقضا"}
            />
        </EditView>
    );
}

export const SubscriptionShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show"  label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show"  label="صورت حساب" source="invoiceId" reference="invoice" >
            <TextField source="title"/>
        </ReferenceField>
        <BooleanField source="isDeleted" />
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
        <ReferenceField link="show" label="نوع پلن" source="planTypeId" reference="planType" >
            <TextField source="title"/>
        </ReferenceField>
        <DateField showTime={true} locales={"fa-IR"} source="expirationDate"/>
    </SimpleShowLayout>
  </ShowView>
);
